import { YOO_FINDS_CDN } from "@/common";

const ROOT = `${YOO_FINDS_CDN}/h5/holiday/beauty-picks`;

export const BEAUTY_PICKS_PRODUCT_SECTION_BANNER = `${ROOT}/banner-v2.png?imageMogr2/thumbnail/!80p/format/webp`;
export const BEAUTY_PICKS_PRODUCT_SECTION_CONTENT_BG = `${ROOT}/content-bg.webp`;
export const BEAUTY_PICKS_PRODUCT_SECTION_ICON_TOP1 = `${ROOT}/icon-top1.svg`;
export const BEAUTY_PICKS_PRODUCT_SECTION_ICON_TOP2 = `${ROOT}/icon-top2.svg`;
export const BEAUTY_PICKS_PRODUCT_SECTION_ICON_TOP3 = `${ROOT}/icon-top3.svg`;
export const BEAUTY_PICKS_PRODUCT_SECTION_LIPSTICK = `${ROOT}/lipstick.png`;
